import { IApplicantService } from "../../service/applicant/ApplicantService";

export default class GetApplicantReportingPeriodsInteractor {
  private applicantService: IApplicantService;

  constructor(applicantService) {
    this.applicantService = applicantService;
  }

  async execute(applicantId: number) {
    return this.applicantService.getApplicantReportingPeriods(applicantId);
  }
}
